module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/level-1_start-fa7258753d8cfafa05d92649458bde53.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/level-1_start.png
// module id = 420
// module chunks = 2